// SVG inline y clasificación por extensión, como hacía v1 con get_logo().
// Nunca se arma markup a partir del nombre del archivo, que es como v1 terminó
// con XSS almacenado.

export type TipoArchivo =
  | 'carpeta'
  | 'imagen'
  | 'documento'
  | 'planilla'
  | 'presentacion'
  | 'pdf'
  | 'comprimido'
  | 'audio'
  | 'video'
  | 'codigo'
  | 'texto'
  | 'ejecutable'
  | 'generico';

const POR_EXTENSION: Record<string, TipoArchivo> = {
  jpg: 'imagen', jpeg: 'imagen', png: 'imagen', gif: 'imagen', webp: 'imagen',
  svg: 'imagen', bmp: 'imagen', ico: 'imagen', avif: 'imagen', heic: 'imagen',
  doc: 'documento', docx: 'documento', odt: 'documento', rtf: 'documento',
  xls: 'planilla', xlsx: 'planilla', ods: 'planilla', csv: 'planilla',
  ppt: 'presentacion', pptx: 'presentacion', odp: 'presentacion',
  pdf: 'pdf',
  zip: 'comprimido', rar: 'comprimido', '7z': 'comprimido', tar: 'comprimido',
  gz: 'comprimido', bz2: 'comprimido', xz: 'comprimido',
  mp3: 'audio', wav: 'audio', ogg: 'audio', flac: 'audio', m4a: 'audio', aac: 'audio',
  mp4: 'video', avi: 'video', mkv: 'video', mov: 'video', wmv: 'video', webm: 'video',
  js: 'codigo', ts: 'codigo', tsx: 'codigo', jsx: 'codigo', json: 'codigo',
  html: 'codigo', css: 'codigo', php: 'codigo', py: 'codigo', java: 'codigo',
  sql: 'codigo', sh: 'codigo', xml: 'codigo', yml: 'codigo', yaml: 'codigo',
  txt: 'texto', md: 'texto', log: 'texto',
  exe: 'ejecutable', msi: 'ejecutable', apk: 'ejecutable', deb: 'ejecutable', dmg: 'ejecutable',
};

export function tipoDeArchivo(nombre: string, esCarpeta: boolean): TipoArchivo {
  if (esCarpeta) return 'carpeta';
  const punto = nombre.lastIndexOf('.');
  if (punto <= 0) return 'generico';
  return POR_EXTENSION[nombre.slice(punto + 1).toLowerCase()] ?? 'generico';
}

const TRAZOS: Record<TipoArchivo, string> = {
  carpeta:
    'M2 5.2A1.7 1.7 0 0 1 3.7 3.5h4.1l1.6 2h7A1.7 1.7 0 0 1 18 7.2v9.1a1.7 1.7 0 0 1-1.7 1.7H3.7A1.7 1.7 0 0 1 2 16.3V5.2Z',
  imagen:
    'M3 4.5h14v11H3v-11Zm2 8.5 3-3.5 2.2 2.6 2.4-3.4L15 13H5Zm2.8-5.3a1.3 1.3 0 1 1-2.6 0 1.3 1.3 0 0 1 2.6 0Z',
  documento: 'M5 2h6l4 4v12H5V2Zm6 1.4V6h2.6L11 3.4ZM7 10h6v1.3H7V10Zm0 3h6v1.3H7V13Z',
  planilla:
    'M3.5 3.5h13v13h-13v-13Zm1.6 3v2.3h3.6V6.5H5.1Zm5.2 0v2.3h3.6V6.5h-3.6Zm-5.2 3.9v2.3h3.6v-2.3H5.1Zm5.2 0v2.3h3.6v-2.3h-3.6Z',
  presentacion:
    'M3 3.5h14v9.5H3V3.5Zm6.2 10.8h1.6v1.4l2.4 1.4-.8 1.3-2.4-1.4-2.4 1.4-.8-1.3 2.4-1.4v-1.4Z',
  pdf: 'M5 2h6l4 4v12H5V2Zm6 1.4V6h2.6L11 3.4ZM7 9.5h1.7c.9 0 1.5.6 1.5 1.5s-.6 1.5-1.5 1.5H8.1v1.4H7V9.5Zm1.1 1v1h.5c.3 0 .5-.2.5-.5s-.2-.5-.5-.5h-.5Zm3.1-1h1.5c1.1 0 1.8.9 1.8 2.2s-.7 2.2-1.8 2.2h-1.5V9.5Zm1.1 1v2.4h.3c.5 0 .8-.5.8-1.2s-.3-1.2-.8-1.2h-.3Z',
  comprimido:
    'M5 2h10v16H5V2Zm4.2 1.5h1.6V5H9.2V3.5Zm0 3h1.6V8H9.2V6.5Zm0 3h1.6V11H9.2V9.5Zm-.3 3h2.2l.4 3.2H8.5l.4-3.2Z',
  audio:
    'M12.5 2.5 7 6.5H3.5v7H7l5.5 4v-15Zm2.6 3.2a6 6 0 0 1 0 8.6l-1.1-1.1a4.4 4.4 0 0 0 0-6.4l1.1-1.1Z',
  video: 'M2.5 4.5h10v11h-10v-11Zm11.5 3.8 3.5-2.3v8l-3.5-2.3V8.3Z',
  codigo: 'M7.3 5.6 3 10l4.3 4.4 1.2-1.2L5.4 10l3.1-3.2-1.2-1.2Zm5.4 0-1.2 1.2L14.6 10l-3.1 3.2 1.2 1.2L17 10l-4.3-4.4Z',
  texto:
    'M5 2h6l4 4v12H5V2Zm6 1.4V6h2.6L11 3.4ZM7 9h6v1.2H7V9Zm0 2.6h6v1.2H7v-1.2Zm0 2.6h3.6v1.2H7v-1.2Z',
  ejecutable:
    'M4 4.5h12v11H4v-11Zm1.8 2.2v1.5h8.4V6.7H5.8Zm1 3.3 2 2-2 2 .9.9 2.9-2.9-2.9-2.9-.9.9Z',
  generico: 'M5 2h6l4 4v12H5V2Zm6 1.4V6h2.6L11 3.4Z',
};

export function Icono({ tipo, className }: { tipo: TipoArchivo; className?: string }) {
  return (
    <svg
      className={className ? `icono ${className}` : 'icono'}
      data-tipo={tipo}
      viewBox="0 0 20 20"
      aria-hidden="true"
    >
      <path d={TRAZOS[tipo]} />
    </svg>
  );
}

export function IconoDe({ nombre, esCarpeta }: { nombre: string; esCarpeta: boolean }) {
  return <Icono tipo={tipoDeArchivo(nombre, esCarpeta)} />;
}
